/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GroupsFilter = {
    /**
     * Number of results to return.
     */
    limit?: number;
    /**
     * Which field to use when ordering the results. Available fields: `id`
     */
    ordering?: string;
}
export const EmptyGroupsFilter: GroupsFilter = {
    limit: 20,
    ordering: undefined,
}